import { render, staticRenderFns } from "./Actualizar.vue?vue&type=template&id=5b012ab9&scoped=true&"
import script from "./Actualizar.vue?vue&type=script&lang=js&"
export * from "./Actualizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b012ab9",
  null
  
)

export default component.exports